import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// Not shipped yet: the Coming soon state. Gated by the parent `/leasing` route (module switch +
// `leasing:access`); lazy-loaded so tenants without Leasing never download it.
export const Route = createFileRoute('/_authenticated/leasing/analytics')({
  component: lazyRouteComponent(() => import('&/features/leasing/pages/leasing-coming-soon-page'), 'AnalyticsPage'),
  staticData: { titleKey: 'leasingAnalytics' },
});
